import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/backoffice`;

export const BackOfficeActions = {
    find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: search}).then(r => {
            if (r.status === 200) {
                let items = r.data.map(element => {
                    const ca = Constants.formatFromDate(element.created_at);
                    const ea = Constants.formatFromDate(element.expires_at);
                    return {
                        ...element,
                        created_at: ca ? ca : '',
                        expires_at: ea ? ea : '',
                    };
                });
                // save to store
                commit('SET_BO_ITEMS', items);
            }
        });
    },

    add: ({commit, state}, data) => {
        return $http.post(url, data, state.authHeader).then(r => {
            if (r.status === 200) {
                commit('SET_BO_ITEM', r.data);
            }
        });
    },

    edit: ({dispatch, commit, state}, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader).then(r => {
            if (r.status === 200) {
                dispatch('backofficeFind');
            }
        });
    },

    delete: ({commit, state}, id) => {
        if (id) {
            return $http.delete(`${url}/${id}`, state.authHeader).then(r => {
                if (r.status === 200) {
                    commit('DELETE_BO_ITEM', id);
                }
            });
        }
    },

    get: ({_, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },
};